var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h4", { staticClass: "border-bottom pb-05 mb-1" }, [
        _vm._v(_vm._s(_vm.__("group.title_pending_join_requests"))),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.search_term,
            expression: "search_term",
          },
        ],
        staticClass: "form-control round",
        attrs: {
          type: "text",
          name: "search_term",
          id: "search_term",
          placeholder: "Type to search...",
        },
        domProps: { value: _vm.search_term },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.search_term = $event.target.value
            },
            _vm.debounceInput,
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "max-height": "655px", "overflow-y": "auto" } },
        _vm._l(_vm.members, function (member, index) {
          return _c(
            "ul",
            { key: index, staticClass: "list-group m-1 p-0" },
            [
              _c("pending-followers", {
                attrs: { member: member, type: _vm.type, slug: _vm.slug },
                on: {
                  updatePending: function ($event) {
                    return _vm.updatePending(index)
                  },
                },
              }),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "infinite-loading",
        {
          ref: "infiniteLoadingJoins",
          attrs: { identifier: _vm.infiniteId },
          on: {
            distance: function ($event) {
              1
            },
            infinite: _vm.infiniteHandler,
          },
        },
        [
          _c("div", { attrs: { slot: "no-more" }, slot: "no-more" }),
          _vm._v(" "),
          _c("div", { attrs: { slot: "no-results" }, slot: "no-results" }, [
            _vm._v(
              " " +
                _vm._s(_vm.__("group.form.validation.no_pending_join_requests"))
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }